import React, { useMemo } from 'react';
import ReactECharts from 'echarts-for-react';
import './SupplyMonthlyCharts.css';

const fmtMonthLabel = (baseDt) => {
  const text = String(baseDt || '');
  if (!/^\d{4}-\d{2}/.test(text)) return text;
  return `'${text.slice(2, 4)}.${text.slice(5, 7)}`;
};

function PresaleSupplyChart({
  regionName,
  title,
  scope = 'sigungu',
  onScopeChange,
  data = [],
}) {
  const chartOption = useMemo(() => {
    const safeRows = Array.isArray(data) ? data : [];
    const labels = safeRows.map((row) => fmtMonthLabel(row?.baseDt));
    const general = safeRows.map((row) => Number(row?.presaleGeneralHouseholdCount || 0));
    const union = safeRows.map((row) => Number(row?.presaleUnionHouseholdCount || 0));
    const rental = safeRows.map((row) => Number(row?.presaleRentalHouseholdCount || 0));
    const other = safeRows.map((row) => Number(row?.presaleOtherHouseholdCount || 0));

    return {
      animationDuration: 450,
      grid: {
        left: 46,
        right: 16,
        top: 30,
        bottom: 48,
        containLabel: true,
      },
      legend: {
        top: 0,
        left: 0,
        itemWidth: 10,
        itemHeight: 10,
        textStyle: { fontSize: 11, color: '#475569', fontWeight: 700 },
      },
      tooltip: {
        trigger: 'axis',
        axisPointer: { type: 'shadow' },
      },
      xAxis: {
        type: 'category',
        data: labels,
        axisTick: { show: false },
        axisLabel: { color: '#64748b', fontSize: 11, hideOverlap: true },
        axisLine: { lineStyle: { color: '#dce4ee' } },
      },
      yAxis: {
        type: 'value',
        axisLabel: {
          color: '#64748b',
          formatter: (value) => {
            const num = Number(value || 0);
            if (num >= 10000) return `${(num / 10000).toFixed(1).replace(/\.0$/, '')}만`;
            if (num >= 1000) return `${(num / 1000).toFixed(1).replace(/\.0$/, '')}천`;
            return num.toLocaleString('ko-KR');
          },
        },
        splitLine: { lineStyle: { color: '#e8edf4' } },
      },
      series: [
        {
          name: '일반',
          type: 'bar',
          stack: 'households',
          data: general,
          barWidth: 9,
          itemStyle: { color: '#4aa3f0' },
        },
        {
          name: '조합',
          type: 'bar',
          stack: 'households',
          data: union,
          itemStyle: { color: '#13b8c7' },
        },
        {
          name: '임대',
          type: 'bar',
          stack: 'households',
          data: rental,
          itemStyle: { color: '#8ecf45' },
        },
        {
          name: '기타',
          type: 'bar',
          stack: 'households',
          data: other,
          itemStyle: { color: '#f4a044' },
        },
      ],
    };
  }, [data]);

  return (
    <section className="supply-monthly-card">
      <div className="supply-monthly-head">
        <h3>{title || `${regionName} 아파트 분양물량`}</h3>
        <div className="supply-monthly-scope">
          <button type="button" className={scope === 'sido' ? 'active' : ''} onClick={() => onScopeChange?.('sido')}>시/도</button>
          <button type="button" className={scope === 'sigungu' ? 'active' : ''} onClick={() => onScopeChange?.('sigungu')}>구</button>
        </div>
      </div>
      <div className="supply-monthly-unit">단위: 세대</div>
      <ReactECharts option={chartOption} style={{ width: '100%', height: '330px' }} notMerge lazyUpdate />
    </section>
  );
}

export default PresaleSupplyChart;
